import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function preguntaReducer(state= initialState.pregunta, action){
    let newState;
	switch(action.type){
         case types.LOAD_PREGUNTA_LIST_SUCCESS:		
            action.pregunta.filtroActivo=state.filtroActivo;
            action.pregunta.filtroActual=state.filtroActual;
            action.pregunta.showActivos=state.showActivos;
			 action.pregunta.paginaActual=action.pregunta.pageable.pageNumber;
			 action.pregunta.registrosPorPagina=action.pregunta.size;
            
            return action.pregunta;

        case types.BORRAR_PREGUNTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(pregunta => pregunta.id !== action.pregunta.id)];          
			return newState;    
            
        case types.ACTIVAR_PREGUNTA_SUCCESS:		            
            newState=Object.assign({}, state);
            newState.content=[...state.content.filter(pregunta => pregunta.id !== action.pregunta.id)];          
            return newState;
            
        case types.SET_FILTRO_PREGUNTA:
			newState=Object.assign({}, state);
			newState.filtroActivo=action.filtro.filtroActivo;
			newState.filtroActual=action.filtro.filtroActual;
            newState.showActivos=action.filtro.showActivos;
            newState.filtrosCombo=action.filtro.filtrosCombo;
            
            
			return newState;
		break;
            
		default:
			return state;
	}
}